import { LicensesType, TLicensePrice, TLicensePriceListDTO } from '@/core/infra';
import { instanceFetch } from '@/fetch';
import { LICENSE_PRICE_CONFIG } from '@/core/constants';

const normalizeLicenses = (data) =>
  data.reduce(
    (acc, item: TLicensePrice) => [
      ...acc,
      {
        ...item,
        type: LICENSE_PRICE_CONFIG[item.name]?.type as LicensesType,
      },
    ],
    [] as TLicensePriceListDTO
  );

export const getPrices = async () => {
  return await instanceFetch
    .get(`/prices`)
    .then((data) => {
      const sortedPrice = data
        .sort((a, b) => a.id - b.id)
        .filter((price) => !LICENSE_PRICE_CONFIG[price.name].disabled);

      return normalizeLicenses(sortedPrice) as TLicensePriceListDTO;
    })
    .catch();
};
